import { AccountCategory } from '../enums/management-input.enum.ts'
import { DefaultOptionType } from 'antd/es/select/index'

const baseCategories = [
  AccountCategory.Global,
  AccountCategory.Japan,
  AccountCategory.GreaterChinaLowNet,
  AccountCategory.GreaterChinaLongBias,
  AccountCategory.India,
  AccountCategory.Korea,
]

export const getCategoryOptions = (t: (key: string) => string) => [
  { value: '', label: t('common.user_controls.all_categories') },
  ...baseCategories.map((cat) => ({ value: cat, label: cat })),
]

export const getRankingCategoryOptions = (t: (key: string) => string) => [
  { value: 'All', label: t('common.user_controls.all_categories') },
  ...baseCategories.map((cat) => ({ value: cat, label: cat })),
]

export const regionOptions = [
  { value: 'Japan', label: 'Japan' },
  { value: 'Greater China', label: 'Greater China' },
  { value: 'India', label: 'India' },
  { value: 'Korea', label: 'Korea' },
]

const NET_CATEGORY_MAP = new Map([
  ['Global', [{ value: 'Global', label: 'Global' } as DefaultOptionType]],
  ['Japan', [{ value: 'Japan', label: 'Japan' } as DefaultOptionType]],
  [
    'Greater China',
    [
      { value: 'Long Bias', label: 'Long Bias' } as DefaultOptionType,
      { value: 'Low Net', label: 'Low Net' } as DefaultOptionType,
    ],
  ],
  ['India', [{ value: 'India', label: 'India' } as DefaultOptionType]],
  ['Korea', [{ value: 'Korea', label: 'Korea' } as DefaultOptionType]],
])

export function getNetCategories(region: string): DefaultOptionType[] {
  return NET_CATEGORY_MAP.get(region) ?? []
}

export function getMatchedCombinedCategory(
  region: string,
  netCategory: string,
  t: (key: string) => string
): string | undefined {
  let combinedCategory = region
  if (region === 'Greater China' && netCategory) {
    combinedCategory = `${region} - ${netCategory}`
  }
  const categoryOptions = getCategoryOptions(t)
  const match = categoryOptions.find((opt) => opt.value === combinedCategory)
  return match ? combinedCategory : undefined
}
